/* @flow */
import styled from 'styled-components'
import THEME from './Soundcloud6.theme'
import {
  styleProvider,
  getBackgroundStyles,
  getTextStyleByAlignment
} from '@website/common/utils'
import WMContainer from '@website/common/components/WMContainer'
import Container from '@website/common/components/Container'

const getStyleForProp = styleProvider(THEME)

const WmCustomContainer = styled(WMContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 0;
  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`

const StyledContainer = styled(Container)`
  ${getBackgroundStyles(THEME)};
  flex-direction: column;
  padding: ${({ isEditing }) => (isEditing ? '150px 0 80px 0' : '80px 0')};
  @media only screen and (max-width: 457px) {
    padding: ${({ isEditing }) => (isEditing ? '120px 0 60px 0' : '60px 0')};
  }
`

const TextContent = styled.div`
  width: 100%;
  max-width: 520px;
  margin: 0 35px 0 0;
  @media only screen and (max-width: 1024px) {
    margin: 0;
    max-width: 100%;
  }

  > :last-child {
    margin-bottom: 0;
  }
  & > .control-container {
    margin-bottom: 30px;
    p,
    h1 {
      padding: 0;
      margin-bottom: 0;
    }
  }
`

const Title = styled.h1`
  color: ${getStyleForProp('heading')};
  ${getTextStyleByAlignment};
  margin-bottom: 20px;
`

const Paragraph = styled.p`
  color: ${getStyleForProp('heading')};
  ${getTextStyleByAlignment};
`

const Name = styled.p`
  color: ${getStyleForProp('heading')};
`

const MusicWrapper = styled.div`
  width: 630px;
  min-width: 630px;
  font-size: 0;
  @media only screen and (min-width: 1023px) {
    &:only-child {
      position: relative;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  @media only screen and (max-width: 1024px) {
    margin-top: 50px;
    &:only-child {
      margin: 0;
    }
  }
  @media only screen and (max-width: 650px) {
    width: 300px;
    min-width: 300px;
    max-width: 600px;
    &:only-child {
      margin: 0;
    }
  }
  @media only screen and (max-width: 457px) {
    margin-top: 40px;
  }
`

const MusicContent = styled.div`
  border-radius: ${getStyleForProp('cardRadius')};
  overflow: hidden;
  position: relative;
  width: 100%;
`

const IframeWrapper = styled.div`
  width: 100%;
  position: relative;
  iframe {
    width: 100%;
    height: 350px;
  }
`

export default {
  WmCustomContainer,
  StyledContainer,
  Title,
  Paragraph,
  Name,
  MusicContent,
  IframeWrapper,
  TextContent,
  MusicWrapper
}
